(() => {
  const coverImageDesktop = qs('.js-video-cover-desktop');
  if (coverImageDesktop) {
    coverImageDesktop.addEventListener('click', () => {
      qs('.video__cover-desktop').style.opacity = 0;
      qs('.video__player-contents').style.opacity = 1;
    });
  }

  const coverImageMobile = qs('.js-video-cover-mobile');
  if (coverImageMobile) {
    coverImageMobile.addEventListener('click', () => {
      qs('.video__cover-mobile').style.opacity = 0;
      qs('.video__player-contents').style.opacity = 1;
    });
  }
})();
